module.exports = __webpack_public_path__ + "img/fy2.f030d052.png";